import React from 'react';
import { OneWayInStatus } from 'src/api/v2';

import { determineTagType, translateStatusTag } from '../helpers/statusTags';
import { Tag } from '@innovationnorway/cl-react';

type Props = {
  status: OneWayInStatus | undefined;
  className?: string;
};
const OneWayInOpportunityStatusTag = ({ status, className }: Props) => {
  return (
    <Tag data-color={determineTagType(status)} className={className}>
      {translateStatusTag(status)}
    </Tag>
  );
};

export default OneWayInOpportunityStatusTag;
